import {AlgorandChainIDs} from "@perawallet/connect/dist/util/peraWalletTypes";

import {ALGOD_CREDENTIALS, AlgorandNodeProviderType} from "./algodConstants";
import {IS_USING_MAINNET, NetworkToggleValue, PREFERRED_NETWORK} from "../../constants";

function getAlgosdkCredentialsForNetwork(credentialType: AlgorandNodeProviderType) {
  const {mainnet: mainnetCredentials, testnet: testnetCredentials} = ALGOD_CREDENTIALS;

  let credentials: {
    tokens: {
      client: string;
      indexer: string;
    };
    server: {
      client: string;
      indexer: string;
    };
    port: number;
  };

  if (IS_USING_MAINNET) {
    credentials = {
      tokens: {
        client: mainnetCredentials[credentialType].clientToken,
        indexer: mainnetCredentials[credentialType].indexerToken
      },
      server: {
        client: mainnetCredentials[credentialType].clientServer,
        indexer: mainnetCredentials[credentialType].indexerServer
      },
      port: mainnetCredentials[credentialType].port
    };
  } else {
    credentials = {
      tokens: {
        client: testnetCredentials[credentialType].clientToken,
        indexer: testnetCredentials[credentialType].indexerToken
      },
      server: {
        client: testnetCredentials[credentialType].clientServer,
        indexer: testnetCredentials[credentialType].indexerServer
      },
      port: testnetCredentials[credentialType].port
    };
  }

  return credentials;
}

function getChainId(): AlgorandChainIDs {
  switch (PREFERRED_NETWORK) {
    case NetworkToggleValue.MainNet:
      // eslint-disable-next-line no-magic-numbers
      return 416001;
    case NetworkToggleValue.TestNet:
      // eslint-disable-next-line no-magic-numbers
      return 416002;
    default:
      throw new Error(`Unknown chain type: ${PREFERRED_NETWORK}`);
  }
}

export {getAlgosdkCredentialsForNetwork, getChainId};
